import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import CollectionForm from "./CollectionComponents/CollectionForm";

import {
  useGetCollectionDetailQuery,
  useUpdateCollectionMutation,
} from "store/services/collectionApi";

import { useAppMeta } from "hooks";

const CollectionEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Collections", path: "/app/crm/collection/list" },
    { title: "Edit Collection" },
  ];

  // RTK Query
  const {
    data: fulfillmentDetail,
    isLoading: loadingFulfillment,
    error,
  } = useGetCollectionDetailQuery(id);

  const [updateCollection, { isLoading: updatingFulfillment }] =
    useUpdateCollectionMutation();

  // Update handler
  const handleUpdateFulfillment = async (data) => {
    const payload = { id, ...data };

    try {
      await updateCollection(payload).unwrap();
      toast.success("Collection successfully updated!");
      navigate(`/app/crm/collection/${id}/detail`); // Redirect to collection Detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update fulfillment!"
      );
    }
  };

  useAppMeta("Edit Collection");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingFulfillment || updatingFulfillment}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CollectionForm
          isBusy={loadingFulfillment || updatingFulfillment}
          fulfillmentDetail={fulfillmentDetail}
          onSubmit={handleUpdateFulfillment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CollectionEditScreen;
